// 261010 UI-assettabs — hàng đầu của ba tab Nhân vật · Bối cảnh · Đạo cụ theo kiểu bảng: tiêu đề + dòng phụ, công tắc «Chỉ hiện của tập này», nút phụ (wf-btn), nút thêm (wf-btn primary = kiểu nút chính của bảng), tải lại = nút biểu tượng.
// Không có handler riêng — chỉ vẽ; mọi `onClick` do tab truyền vào.
import React from 'react';
import WfIcon from './WfIcon';
import WfIconButton from './WfIconButton';
import './assetCards.css';

export const AssetTabHead: React.FC<{
  title: string;
  sub?: string;
  /** Nút phụ + công tắc (đứng trước nút thêm + tải lại). */
  children?: React.ReactNode;
  onRefresh: () => void;
  refreshing?: boolean;
  testId?: string;
}> = ({ title, sub, children, onRefresh, refreshing, testId }) => (
  <div className="ac-head" data-testid={testId}>
    <h3>{title}</h3>
    {sub ? <span className="sub">{sub}</span> : null}
    <span className="sp" />
    {children}
    <WfIconButton icon="reload" label="Tải lại" onClick={onRefresh} loading={refreshing} />
  </div>
);

/** Nút thêm của đầu tab (kiểu nút chính của bảng, không phải nút xanh antd). Là `<button>` thật để Tooltip/Popconfirm bọc được. */
export const AssetAddButton = React.forwardRef<HTMLButtonElement, React.ButtonHTMLAttributes<HTMLButtonElement>>(({ children, className, ...rest }, ref) => (
  <button ref={ref} type="button" className={`wf-btn primary${className ? ` ${className}` : ''}`} {...rest}><WfIcon name="plus" />{children}</button>
));
AssetAddButton.displayName = 'AssetAddButton';

/** Nút phụ chữ của đầu tab (kiểu `wf-btn`). */
export const AssetHeadButton = React.forwardRef<HTMLButtonElement, React.ButtonHTMLAttributes<HTMLButtonElement>>(({ children, className, ...rest }, ref) => (
  <button ref={ref} type="button" className={`wf-btn${className ? ` ${className}` : ''}`} {...rest}>{children}</button>
));
AssetHeadButton.displayName = 'AssetHeadButton';
